import { z } from "zod";
import { defineStepConfig } from "../../../registry/helpers";

/**
 * Detect Deductions From Remittance Step
 *
 * After invoice references are resolved and deduction line items materialized
 * (invoice-tied discounts/adjustments and standalone general claims), walk
 * those `deduction`-kind line items and open a `deduction` collection thread
 * for each one that clears the org-configured threshold.
 *
 * Deduction threads open in a `pending_validation` approval state — an AR rep
 * validates the claim before it resolves. Unlike short-pay/over-payment there
 * is no partial unique index; the detection service dedups in-process on the
 * originating remittance line item.
 */
export const detectDeductionsFromRemittanceStep = defineStepConfig({
  type: "detect_deductions_from_remittance",
  name: "Detect Deductions From Remittance",
  description:
    "Open deduction collection threads for deduction-kind remittance line items that clear the org threshold",
  category: "Data Access",
  libraryModule: "AccountsReceivable",
  inputSchema: z.object({
    remittanceAdviceId: z
      .uuid()
      .describe(
        "Remittance advice whose deduction line items will be checked for deductions",
      ),
  }),
  outputSchema: z.object({
    created: z.int().nonnegative(),
    skipped: z.int().nonnegative(),
    failed: z.int().nonnegative(),
  }),
  configSchema: z.object({}),
  emits: [] as const,
});
